import {apiConnector} from "./apiconnector";
const API_URL = process.env.REACT_APP_API_URL;
// Game Management APIs
export const getGames = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) searchParams.append(key, params[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/games?${searchParams}`);
    return response;
  } catch (error) {
    console.error('Error fetching games:', error);
    throw error;
  }
};

export const getGameById = async (id) => {
  try {
    const response = await apiConnector('GET', `${API_URL}/games/${id}`);
    return response;
  } catch (error) {
    console.error('Error fetching game by ID:', error);
    throw error;
  }
};

export const createGame = async (gameData) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/games`, gameData);
    return response;
  } catch (error) {
    console.error('Error creating game:', error);
    throw error;
  }
};

export const updateGame = async (id, gameData) => {
  try {
    const response = await apiConnector('PUT', `${API_URL}/games/${id}`, gameData);
    return response;
  } catch (error) {
    console.error('Error updating game:', error);
    throw error;
  }
};

export const deleteGame = async (id) => {
  try {
    const response = await apiConnector('DELETE', `${API_URL}/games/${id}`);
    return response;
  } catch (error) {
    console.error('Error deleting game:', error);
    throw error;
  }
};

export const submitGameScore = async (gameId, scoreData) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/games/${gameId}/score`, scoreData);
    return response;
  } catch (error) {
    console.error('Error submitting game score:', error);
    throw error;
  }
};

export const getMyGameScores = async () => {
  try {
    const response = await apiConnector('GET', `${API_URL}/games/my-scores`);
    return response;
  } catch (error) {
    console.error('Error fetching my game scores:', error);
    throw error;
  }
};

export const getLeaderboard = async (timeframe = 'all') => {
  try {
    const response = await apiConnector('GET', `${API_URL}/games/leaderboard?timeframe=${timeframe}`);
    return response;
  } catch (error) {
    console.error('Error fetching leaderboard:', error);
    throw error;
  }
};

export const getUserGamificationStats = async () => {
  try {
    const response = await apiConnector('GET', `${API_URL}/games/stats`);
    return response;
  } catch (error) {
    console.error('Error fetching user gamification stats:', error);
    throw error;
  }
};

// Legacy function for backward compatibility
export const addUserPoints = async (userId, points) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/games/add-points`, { userId, points });
    return response;
  } catch (error) {
    console.error('Error adding user points:', error);
    throw error;
  }
};